<template>
    <ul>
        <li
            class="nav-item active"
            :class="[isVerticalMenuCollapsed ? 'text-center m-1' : '']"
        >
            <b-img
                id="gLogo"
                :src="isVerticalMenuCollapsed ? appLogoNavCollapse : appLogoNav"
                alt="Logo Salem"
            />
        </li>

        <component
            :is="resolveNavItemComponent(item)"
            v-for="item in items"
            :key="item.header || item.title"
            :item="item"
        />
    </ul>
</template>

<script>
import { computed, provide, ref } from 'vue'
import { $themeConfig } from '@themeConfig'
import { BImg } from 'bootstrap-vue'
import useAppConfig from '@core/app-config/useAppConfig'
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import store from '@/store/index'

export default {
    components: {
        BImg,
        VerticalNavMenuHeader,
        VerticalNavMenuLink,
        VerticalNavMenuGroup,
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    setup() {
        provide('openGroups', ref([]))

        const { isVerticalMenuCollapsed } = useAppConfig()

        const appLogoNav = computed(() =>
            store.state.appConfig.layout.skin.includes('dark')
                ? $themeConfig.app.appLogoNavB
                : $themeConfig.app.appLogoNav
        )

        const appLogoNavCollapse = computed(() =>
            store.state.appConfig.layout.skin.includes('dark') ? $themeConfig.logos.logo2b : $themeConfig.logos.logo2
        )

        return {
            resolveNavItemComponent,
            appLogoNav,
            appLogoNavCollapse,
            isVerticalMenuCollapsed,
        }
    },
}
</script>

<style>
#gLogo {
    margin-top: 5px;
}
</style>
